<template lang="pug">
div(v-if='grafico_acucar === "linha"')
    apex-charts.component.apexcharts-canvas(
        type='line',
        height='300',
        :options='options',
        :series='seriesGraficoAcucar',
        ref='chart'
    )
div(v-else-if='grafico_acucar === "barra"')
    apex-charts.component.apexcharts-canvas(
        type='bar',
        height='300',
        :options='options',
        :series='seriesGraficoAcucar',
        ref='chart'
    )
div(v-else)
    .tabela
        el-table(:data='dadosTabela', stripe, cell-style='text-align: left')
            el-table-column(label='Semana Data Entrada', prop='dataVolume')
                template(slot-scope='scope')
                    span {{ scope.row.dataEntrada }}
            el-table-column(label='Entrada de Volume', prop='entradaVolume')
                template(slot-scope='scope')
                    span {{ scope.row.valorEntrada }}
            el-table-column(label='Saida de Volume', prop='saidaVolume')
                template(slot-scope='scope')
                    span {{ scope.row.valorSaida }}
            el-table-column(label='Saldo', prop='saldo')
                template(slot-scope='scope')
                    span {{ scope.row.valorSaldo }}
</template>

<script>
import ApexCharts from 'vue-apexcharts';
import EmptyResult from '../EmptyResult';

export default {
    name: 'GraficoLinhaRastreabilidade',
    components: {
        ApexCharts,
        EmptyResult
    },
    props: {
        grafico_acucar: {
            type: String,
            default: () => 'linha'
        },
        dadosTabela: {
            type: Array,
            default: () => []
        },
        seriesGraficoAcucar: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            options: {
                chart: {
                    id: 'Grafico-Acucar',
                    zoom: {
                        enabled: false
                    }
                },
                markers: {
                    size: 7
                },
                xaxis: {
                    title: {
                        text: 'Semanas'
                    },
                    categories: ['Semana 1', 'Semana 2', 'Semana 3', 'Semana 4']
                },
                colors: ['#00413C', '#F0614E', '#FAD967'],
                yaxis: {
                    title: {
                        text: 'Toneladas'
                    },
                    showAlways: true,
                    forceNiceScale: true,
                    decimalsInFloat: 0,
                    min: 0
                }
            }
        };
    }
};
</script>

<style lang="scss" scoped>
.tabela {
    min-height: 300px;
    width: 100%;
}
</style>
